import { object, string } from 'yup';
export const Fields = [
    {
        name: 'otp',
        placeholder: 'Enter OTP',
        label: 'OTP',
        helper: true,
        maxLength: 6,
    },
];
export const validationSchema = object({
    otp: string()
        .required('Required')
        .matches(/^[0-9]+$/, 'OTP has to be number only')
        .length(6, 'OTP must be 6 digits'),
});
export const initialValues = {
    otp: '',
};

